export type Room = {
	host: string;

	// includes the host, unless the host went missing
	players: string[];

	// game in progress?
	playing: boolean;
}

export type Rooms = Map<string, Room>;

// Parses the output of JSON into a type Rooms object
export function parseRooms(entries: any): Rooms {
	return new Map<string, Room>(entries as [string, Room][]);
}

// What are all the room names?  (They are named after their hosts.)
export function roomNames(rooms: Rooms): string[] {
	return [...rooms.keys()];
}

// Which room does "player" belong to?
export function findRoom(rooms: Rooms, player: string): Room | null {
	for (let room of rooms.values()) {
		if (room.players.includes(player))
			return room;
	}

	return null;
}

function roomsAddPlayer(rooms: Rooms, room: string, player: string): Rooms {
	const room_ = rooms.get(room);
	if (room_) {
		room_.players.push(player);
	} else {
		rooms.set(room, {
			host: room,
			players: [player],
			playing: false
		});
	}
	return rooms;
}

function invertRoomsMap(map: Map<string, string>): Map<string, Room> {
	const pairs = Array.from(map.entries());
	const playerPairs = pairs.reduce(
		(acc, [player, room]) => roomsAddPlayer(acc, room, player),
		new Map<string, Room>()
	);
	return new Map<string, Room>(playerPairs);
}

export function buildRooms(roomMap: Map<string, string>, gameMap: Map<string, unknown | any>): Rooms {
	const rooms = invertRoomsMap(roomMap);
	rooms.delete("");
	for (let [room, game] of gameMap) {
		rooms.get(room)!.playing = game != null;
	}
	return rooms;
}
